import { useCallback } from 'react';

import { WizardStepConfig } from '@bambi/component-library/src/components/Wizard/base/types';
import { ProgressBarWizard } from '@bambi/component-library/src/components/Wizard/ProgressBarWizard';
import { FormProvider, useForm } from 'react-hook-form';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { Modal } from 'src/common/primitives/Modal';
import { routeTemplateActions } from 'src/features/trip/routeTemplates/routeTemplates.slice';

import { ApplyRouteTemplatesStep1 } from './steps/ApplyRouteTemplatesStep1';
import { ApplyRouteTemplatesStep2 } from './steps/ApplyRouteTemplatesStep2';
import { ApplyRouteTemplateForm } from './types';

export function ApplyRouteTemplatesModal() {
  const open = useAppSelector(
    (state) => state.routeTemplates.showApplyRouteTemplatesModal
  );
  const dispatch = useAppDispatch();

  const setOpen = useCallback(
    (open: boolean) => {
      dispatch(routeTemplateActions.setShowApplyRouteTemplatesModal(open));
    },
    [dispatch]
  );

  const form = useForm<ApplyRouteTemplateForm>({
    defaultValues: {
      selectedRouteTemplatesMap: {},
    },
  });

  const onCancel = useCallback(() => {
    dispatch(routeTemplateActions.setApplyRouteTemplatesResult(null));
    form.reset();
    setOpen(false);
  }, [dispatch, form, setOpen]);

  const steps: WizardStepConfig[] = [
    {
      title: 'Select Route Templates',
      render: ({ next }) => (
        <ApplyRouteTemplatesStep1 onNext={next} onCancel={onCancel} />
      ),
    },
    {
      title: 'Results',
      render: ({ prev }) => (
        <ApplyRouteTemplatesStep2 onBack={prev} onClose={onCancel} />
      ),
    },
  ];

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      onInteractOutside={() => setOpen(false)}
      contentClassnames="w-full max-w-[75vw]"
      title="Apply Route Templates"
    >
      <FormProvider {...form}>
        <ProgressBarWizard steps={steps} />
      </FormProvider>
    </Modal>
  );
}
